<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import MemberJobFairResumeTabView from "./MemberJobFairResumeTabView.vue";
import MemberJobFairInterestedCorpTabView from "./MemberJobFairInterestedCorpTabView.vue";
import MemberJobFairInterestedJobPostingTabView from "./MemberJobFairInterestedJobPostingTabView.vue";
import MemberJobFairInterviewOffersView from "./MemberJobFairInterviewOffersView.vue";

const props = defineProps({
  userId: {
    type: [String, Number],
    required: true,
  }
});

const route = useRoute();
const router = useRouter();
const tabRef = ref(null);

const tabOptions = [
  {label:'이력서 관리 및 입사지원 현황', value: 'resume'},
  {label:'관심기업', value: 'interested-corp'},
  {label:'관심공고', value: 'interested-job-posting'},
  {label:'받은 면접제안', value: 'interview-offers'},
];

const selectedTabValue = ref(tabOptions[0].value);

const onChangeTab = (tab) => {
  selectedTabValue.value = tab.value;
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set("tab2", tab.value);
  window.history.replaceState({}, "", `${window.location.pathname}?${queryParams.toString()}`);
};

onMounted(() => {
  const tabFromQuery = route.query.tab2;
  if (tabFromQuery && tabOptions.some(opt => opt.value === tabFromQuery)) {
    selectedTabValue.value = tabFromQuery;

    if(tabRef.value) {
      tabRef.value.init(tabFromQuery);
    }
  }
});
</script>

<template>
  <div class="tab-wrapper">
    <KSATab
      ref="tabRef"
      style="grid-template-columns: repeat(4, 1fr);" class="mt-n-sm mb-lg"
      :options="tabOptions"
      @change="onChangeTab"
    />

    <div v-if="selectedTabValue === 'resume'">
      <MemberJobFairResumeTabView :user-id="props.userId" />
    </div>
    <div v-if="selectedTabValue === 'interested-corp'">
      <MemberJobFairInterestedCorpTabView :user-id="props.userId" />
    </div>
    <div v-if="selectedTabValue === 'interested-job-posting'">
      <MemberJobFairInterestedJobPostingTabView :user-id="props.userId" />
    </div>
    <div v-if="selectedTabValue === 'interview-offers'">
      <MemberJobFairInterviewOffersView :user-id="props.userId" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-wrap {
  margin-bottom: 20px;
}
</style>